import React from "react";
import { Box } from "@material-ui/core";
import { Form, Formik, FormikProps } from "formik";
import CustomDialog from "../../../../components/Dialog/CustomDialog";
import CustomButton from "../../../../components/Button/CustomButton";
import InternalContactInput from "../inputs/InternalContactInput";
import DescriptionFormType from "../models/Description.form";

export interface InternalContactDialogProps {
  disabled: boolean;
  open: boolean;
  onClose: () => void;
  onConfirm: (values: DescriptionFormType) => void;
  initialValues: DescriptionFormType;
}

const InternalContactDialog: React.FC<InternalContactDialogProps> = (props) => {
  const { disabled, open, onClose, onConfirm, initialValues } = props;

  return (
    <CustomDialog maxWidth="sm" open={open} onClose={onClose}>
      <h2>Check further internal contacts</h2>
      <p>Please check if further internal contacts are authorized to access this test request.</p>
      <Formik<DescriptionFormType> initialValues={initialValues} onSubmit={onConfirm}>
        {(formikProps: FormikProps<DescriptionFormType>): JSX.Element => {
          return (
            <Form>
              <InternalContactInput disabled={disabled} handleDirtyChange={() => {}} {...formikProps} />
              <Box display="flex" justifyContent="flex-end" marginTop="26px">
                <CustomButton type="submit" disabled={disabled} text="Confirm" primary />
              </Box>
            </Form>
          );
        }}
      </Formik>
    </CustomDialog>
  );
};

export default InternalContactDialog;
